<div class="text-center" style="padding: 15px;">
  <div class="row" style="margin: 30px 0px 20px 0px;">
    <div class="col-lg-12">
      <h3>{{'AUTH.GENERAL.DELETEACCOUNT' | translate}}</h3>
    </div>
  </div>
  <div mat-dialog-content style="margin-top: 15px">
    <p>{{'AUTH.GENERAL.DELETEACCOUNTPARA' | translate}}</p>
  </div>
  <div class="text-center" style="margin-top: 30px;">
    <div class="col-lg-12">
      <div class="text-center">
        <button style="font-weight: bold;" type="button" class="btn btn-success" (click)="DeleteAccount()">{{
          'COMMON.YES' |
          translate }}</button>
        <button type="button" style="margin: 10px;font-weight: bold;" class="btn btn-danger" (click)="onNoClick()">{{
          'COMMON.NO' |
          translate }}</button>
        <br>
        <ng-container *ngIf="isLoading$ | async">
          <div class="spinner-border" role="status" style="margin-top: 30px;">
            <span class="visually-hidden"></span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>